<template>
    <div class="sign">
        <h2>请输入手机号密码</h2>
        <van-form @submit="onSubmit">
            <van-cell-group inset>
                <van-field
                        v-model="tel"
                        name="手机号"
                        label="手机号"
                        placeholder="手机号"
                        :rules="[{ required: true, message: '请填写手机号' }]"
                    />
                <van-field
                    v-model="password"
                    type="password"
                    name="密码"
                    label="密码"
                    placeholder="密码"
                    :rules="[{ required: true, message: '请填写密码' }]"
                />
            </van-cell-group>
            <div style="margin: 30px 16px;">
                <van-button round block type="danger" native-type="submit">
                    提交
                </van-button>
            </div>
            <p @click="go()">点我注册</p>
        </van-form>

        <van-popup v-model="show" style="padding:0 40px;width:60%">
            <h2 style="margin-top:20px">选择猪场</h2>
            <van-radio-group v-model="radio">
                <van-radio v-for="(item,i) in list" :name="i+1"  v-if="item.status==1" checked-color="#ee0a24" style="margin-bottom:20px">
                    {{item.zhuchang}}
                </van-radio>
            </van-radio-group>
            <van-button type="danger" @click="changeZhu()" style="margin:30px 0;width:100%">确定</van-button>
        </van-popup>

       
    </div>
</template>

<style scoped lang="less">
    .sign {
        text-align: center;
        h2 {
            margin: 70px 0 40px 0;
        }
        p {
            color: #646566;
            font-weight: 600;
            text-align: right;
            padding-right: 20px;
        }
    }
</style>

<script>
import { url2 } from '../router/api';

export default {
    data() {
        return {
            tel:'',
            password:'',
            show:false,
            radio: '',
            list:'',
        }
    },


    methods: {
        changeZhu() {
            if(this.radio) {
                this.$router.push({
                    path:'./menu',
                    query: { 
                        list: JSON.stringify(this.list[this.radio-1])  
                    }
                })
            }
        },
        go() {
            this.$dialog.confirm({
                message: '请选择注册类别',
                confirmButtonText:'污水污泥',
                cancelButtonText:'饲料',
            })
            .then(() => {
                this.$router.push('./zhuce');
            })
            .catch(() => {
                this.$router.push('./zhuce2');
            });
        },
        onSubmit() {
            this.axios.get(url2 +'sign', {
                params:{
                    tel:this.tel,
                    password:this.password,
                }
            }).then(res=> {
                if(res.data.code==1) {
                    this.list = res.data.data
                    if(res.data.data.length==1) {
                        if(res.data.data[0].zhuchang) {
                            this.$router.push({
                                path:'./menu',
                                query: { 
                                    list: JSON.stringify(this.list[0])  
                                }
                            })
                        } else {
                            this.$router.push({
                                path:'./menu2',
                                query: { 
                                    name: this.list[0].name,
                                    tel: this.list[0].tel
                                }
                            })
                        }
                    } else {
                        this.show = true
                    }
                } else {
                    this.$toast.fail({
                        message: res.data.msg,
                    })
                }
            }).catch(err=> {
                console.log(err);
            });
        },
        
    },
  }
</script>